<div *ngIf="categories.length > 0" class="flex flex-col gap-2.5">
  <div *ngFor="let category of categories" class="flex flex-col gap-0.5">
    <div class="text-xs font-semibold text-neutral-700 dark:text-neutral-300">
      {{ category.label }}
    </div>
    <div
      *ngFor="let item of category.items"
      class="text-xs text-right text-neutral-600 dark:text-neutral-400 pl-6"
    >
      {{ item }}
    </div>
  </div>
</div>
